<template>
  <div id="results" class="results" v-loading.body="loading">
    <el-row style="height:100%">
      <el-col :span="24" style="height:100%;">
        <div style="height:100%;padding:5px;">
          <el-table
            ref="resultsData"
            :data="scenaries"
            highlight-current-row
            v-bind:height="resultsTableHeight"
            @current-change="handleSelect"
            style="width: 100%; height: 100%;"
            :row-class-name="getScenarioRowStyle"
            header-cell-class-name="default-header-color"
            >
            <el-table-column
              property="label"
              label="Сценарий"
              sortable
              class="grid-text-overflow">
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.label }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Начат"
              property="dateStarted"
              sortable
              class="grid-text-overflow"
              width="170">
              <template slot-scope="scope">
                <el-icon name="time"></el-icon>
                <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateStarted)" placement="top">
                  <span class="grid-text-overflow" style="margin-left:10px;">{{ formatDateWithHoursAndMinutes(scope.row.dateStarted) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Закончен"
              property="dateFinished"
              sortable
              class="grid-text-overflow"
              width="170">
              <template slot-scope="scope">
                <el-icon name="time"></el-icon>
                <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateFinished)" placement="top">
                  <span class="grid-text-overflow" style="margin-left:10px;">{{ formatDateWithHoursAndMinutes(scope.row.dateFinished) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              property="statusName"
              label="Статус"
              sortable
              class="grid-text-overflow"
              width="120">
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.statusName" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.statusName }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Операции"
              width="115"
              class="grid-text-overflow">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="Начать тестирование" placement="top">
                  <el-button
                    size="small"
                    icon="el-icon-edit"
                    type="primary"
                    :disabled="scope.row.status === 2 || !scope.row.code"
                    @click="startSelectedScenario(scope.$index, scope.row)">
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-dialog title="Результат сценария" :visible.sync="showResult" style="margin-top:-100px;">
        <div style="height:100%;padding:5px;">
          <el-row style="text-align:center">
            <img src="../../assets/logo-transparent.png" style="height: 150px; width: auto; object-fit: contain; float:both;">
          </el-row>
          <el-row style="text-align:center;padding: 10px 0px 10px 10px;">
            <b>
              Результаты тестирования
            </b>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12" style="text-align:right;">
              <el-row>
                  Испытуемый:
              </el-row>
              <el-row>
                  Сценарий:
              </el-row>
              <el-row>
                  Закончен:
              </el-row>
              <el-row>
                  Затрачено времени:
              </el-row>
            </el-col>
            <el-col :span="12" style="text-align:left;">
              <el-row>
                  <b>{{ userName }}</b>
              </el-row>
              <el-row>
                  <el-tooltip class="item" effect="dark" :content="scenarioLabel" placement="top">
                    <b style="white-space: nowrap">{{ scenarioLabel }}</b>
                  </el-tooltip>
              </el-row>
              <el-row>
                  <b>{{ finishDate }}</b>
              </el-row>
              <el-row>
                  <b>{{ timeElapsed }}</b>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="text-align:center;padding: 10px 0px 10px 10px;">
            <b>
              Сводная информация по тестам
            </b>
          </el-row>
          <el-row :gutter="10" style="padding: 0px 5px 0px 5px;">
            <el-table
              :data="tests"
              border
              show-summary
              :summary-method="getSummaries"
              v-bind:height="testsTableHeight"
              style="width: 100%" header-cell-class-name="default-header-color">
              <el-table-column
                prop="label"
                label="Тест"
                class="grid-text-overflow"
                >
                <template slot-scope="scope">
                   <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
                     <span class="grid-text-overflow">{{ scope.row.label }}</span>
                   </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="correct"
                label="Верно"
                width="80">
              </el-table-column>
              <el-table-column
                prop="wrong"
                label="Не верно"
                width="102">
              </el-table-column>
              <el-table-column
                prop="skipped"
                label="Пропуск"
                width="97">
              </el-table-column>
              <el-table-column
                prop="total"
                label="Всего"
                width="80">
              </el-table-column>
              <el-table-column
                prop="percentage"
                label="Процент"
                width="102">
              </el-table-column>
            </el-table>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeResult">OK</el-button>
        </span>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'
  import grid from '../../api/helpers/grid'
  import contest from '../../api/contest/time'
  import states from '../../api/contest/contest-states'

  export default {
    name: 'results',
    data() {
      return {
        loading: false,
        scenaries: [

        ],
        currentRow: null,
        scenario: null,
        resultsHeight: null,
        showResult: false
      }
    },
    computed: {
      resultsTableHeight: function() {
        if(!this.resultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            return height - 30;
        }
        return this.resultsHeight;
      },
      testsTableHeight: function() {
        let height = this.resultsTableHeight;
        if(height) {
          //return height - (150 + 24 * 2 + 23 * 4 + 40 + 10);
          return 250;
        }
        return null;
      },
      userName: function() {
        if(this.scenario)
          return this.scenario.fullName;
        return '';
      },
      scenarioLabel: function() {
        if(this.scenario)
          return this.scenario.label;
        return '';
      },
      finishDate: function() {
        if(this.scenario)
          return grid.formatDate(this.scenario.dateFinished);
        return '';
      },
      timeElapsed: function() {
        if(this.scenario)
          return contest.formatMinutes(this.scenario.timeElapsedInSeconds);
        return '';
      },
      tests: function() {
        if(this.scenario)
          return this.scenario.tests;
        return [];
      }
    },
    methods: {
      fetchData: function() {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///SCENARIES
          self.$http.get(`${prefix}results`, options)
            .then(response => {
              self.scenaries = response.data;
              this.loading = false;
              //if(self.scenaries && self.scenaries.length)
              //  this.handleSelect(self.scenaries[0]);
            })
            .catch(data => {
              self.$gf.checkError(data);
              this.loading = false;
            });
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      handleSelect(val) {
       this.currentRow = val;
       if(this.currentRow) {
         let uid = this.currentRow.uid;
         if(uid) {
           if(this.currentRow.status !== 2) {
             return;
           }
           this.loading = true;
           let self = this;
           let prefix = config.API_PREFIX;
           this.$gf.getOptions().then(options => {
             options.params = {
             };
             ///TESTS
             self.$http.get(`${prefix}results/${uid}`, options)
               .then(response => {
                 self.scenario = response.data;
                 self.loading = false;
                 self.showResult = true;
               })
               .catch(data => {
                 self.$gf.checkError(data);
                 self.loading = false;
               });
           }).catch(err => {
             this.$gf.catchOptions();
             this.loading = false;
           });
        }
      }
     },
     closeResult() {
       this.showResult = false;
     },
     getSummaries(param) {
       const { columns, data } = param;
       const sums = [];
       if(this.scenario) {
         let total = this.scenario.total;
         if(total) {
           sums[0] = total.label;
           sums[1] = total.correct;
           sums[2] = total.wrong;
           sums[3] = total.skipped;
           sums[4] = total.total;
           sums[5] = total.percentage;
         }
       }

       return sums;
      },
      getScenarioRowStyle(row, rowIndex) {
        if (row) {
          let status = row.row.status;
          if (status) {
            //let color = states.getScenarioStatusColor(status);
            //return 'background-color:' + color;
            return states.getScenarioStatusClass(status);
          }
        }
        //return 'background-color:#cfd1d6';

        return 'scenario0';
      },
      getScenariesHeaderStyle(row, rowIndex) {
        return 'background-color:#324157;color:white;';
      },
      resize() {
        let height = layout.getParentClientHeight();
        if(height)
          this.resultsHeight = height - 30;
        else
          this.resultsHeight = null;
      },
      formatDate(d) {
        return grid.formatDate(d);
      },
      formatDateWithHoursAndMinutes(d) {
        return grid.formatDateWithHoursAndMinutes(d);
      },
      startSelectedScenario(index, row) {
        this.$router.push(config.SCENARIO_WELCOME_URL + '?code=' + `${row.uid}`);
      }
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.resize);
    },
    created: function () {
      window.addEventListener('resize', this.resize);
      this.fetchData();
    }
  }
</script>

<style scoped>
  .results {
    height: calc(100% - 20px);
    background: #eef1f6;
    border: 1px solid #d1dbe5;
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .grid-text-overflow {
    /*overflow:hidden;
    display:inline-block;*/
    /*margin-left: 10px -- it s for items with icons*/
    text-overflow: ellipsis;
    white-space: nowrap;
  }
 </style>

<style>
  .el-table .scenario0 {
    background: #cfd1d6;
  }

  .el-table .scenario1 {
    background: #b3d8ff;
  }

  .el-table .scenario2 {
    background: #c2e7b0;
  }

  .el-table .scenario3 {
    background: #f7d89b;
  }

  .el-table .scenario4 {
    background: #fdbbbb;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalarea/results.vue